module.exports = __webpack_public_path__ + "static/media/GT03_GT_Accommodation-Attributes.ea238e14.csv";